module.exports = __webpack_public_path__ + "img/MyChoice2201_BAB.1c5d92a1.jpg";